import { Component, OnInit, Inject } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material";
import { WebShopMode } from "../../shared/contentTypes";
import { LocationOpenDayViewModel } from "../../shared/models";

interface ILocationData {
  isLocationOpen: boolean;
  locationOpenDays: LocationOpenDayViewModel[];
  serviceMode: WebShopMode;
  hasValidOrderTimes?: boolean;
  hasValidOrderTimesToday?: boolean;
}

@Component({
  selector: "ya-availableservicetime",
  templateUrl: "./availableservicetime.component.html",
  styleUrls: ["./availableservicetime.component.scss"]
})
export class AvailableServiceTimeComponent implements OnInit {
  public availableServiceTitle = "phAvailableService_title_OpenTime"
  public availableServiceContent = "phAvailableService_content_OpenTime";
  public serviceOpenTimeTitle = "phGlobal_OpenTime";
  public openDays: LocationOpenDayViewModel[] = [];

  constructor(public bottomSheetRef: MatBottomSheetRef<AvailableServiceTimeComponent>
    , @Inject(MAT_BOTTOM_SHEET_DATA) public data: ILocationData) {
  }

  ngOnInit() {
    const me = this;
    me.setDialogContent();
  }

  private setDialogContent() {
    const me = this;
    me.openDays = me.data.locationOpenDays;
    const serviceMode = me.data.serviceMode;
    switch (serviceMode) {
      case WebShopMode.Delivery: {
        me.availableServiceTitle = "phAvailableService_title_Delivery";
        me.availableServiceContent = me.detDeliveryContentText();
        me.serviceOpenTimeTitle = "phGlobal_Delivery_openTime";
        break;
      }
      case WebShopMode.TakeAway: {
        me.availableServiceTitle = "phAvailableService_title_Tekeaway";
        me.availableServiceContent = me.detTakeAwayContentText();
        me.serviceOpenTimeTitle = "phGlobal_Pickup_openTime";
        break;
      }
      case WebShopMode.OrderToTable: {
        me.availableServiceTitle = "phAvailableService_title_InHouse";
        me.availableServiceContent = "phAvailableService_content_InHouse";
        me.serviceOpenTimeTitle = "phGlobal_InHouse_openTime";
        break;
      }
      default: {
        me.availableServiceTitle = "phAvailableService_title_OpenTime";
        me.availableServiceContent = "phAvailableService_content_OpenTime";
        me.serviceOpenTimeTitle = "phGlobal_OpenTime";
        break;
      }
    }
  }

  private detDeliveryContentText() {
    const me = this;
    if (me.data) {
      // no valid times today but has valid times later
      if (!me.data.hasValidOrderTimesToday) {
        return "phAvailableService_content_Delivery";
        // no valid times at all
      } else if (!me.data.hasValidOrderTimes) {
        return "phAvailableService_content_NoValidTime_Delivery";
      } else {
        // valid times available
      }
    }
  }

  private detTakeAwayContentText() {
    const me = this;
    if (me.data) {
      // no valid times today but has valid times later
      if (!me.data.hasValidOrderTimesToday) {
        return "phAvailableService_content_Tekeaway";
        // no valid times at all
      } else if (!me.data.hasValidOrderTimes) {
        return "phAvailableService_content_NoValidTime_Takeaway";
      } else {
        // valid times available
      }
    }
  }

  public routeToLocation() {
    const me = this;
    me.bottomSheetRef.dismiss(true);
  }
}
